export const copyStyles = (sourceDoc: Document, targetDoc: Document) => {
  Array.from(sourceDoc.styleSheets).forEach((styleSheet) => {
    try {
      const rules = styleSheet.cssRules;
      const newStyleEl = targetDoc.createElement('style');
      Array.from(rules).forEach((rule) => {
        newStyleEl.appendChild(targetDoc.createTextNode(rule.cssText));
      });
      targetDoc.head.appendChild(newStyleEl);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_err) {
      if (styleSheet.href) {
        const newLinkEl = targetDoc.createElement('link');
        newLinkEl.rel = 'stylesheet';
        newLinkEl.href = styleSheet.href;
        targetDoc.head.appendChild(newLinkEl);
      }
    }
  });
};
// ------------------

export const copyDynamicStyles = (sourceDoc: Document, targetDoc: Document) => {
  // Emotion / MUI injected styles
  sourceDoc
    .querySelectorAll('style[data-emotion], style[data-mui-style]')
    .forEach((style) => {
      const newStyle = targetDoc.createElement('style');
      newStyle.setAttribute(
        'data-emotion',
        `${style.getAttribute('data-emotion')}`
      );
      newStyle.setAttribute(
        'data-mui-style',
        `${style.getAttribute('data-mui-style')}`
      );
      newStyle.textContent = style.textContent;
      targetDoc.head.appendChild(newStyle);
    });
};
// ------------------

export const copyLocalScssInjectedStyles = (
  sourceDoc: Document,
  targetDoc: Document
) => {
  sourceDoc.querySelectorAll('style').forEach((style) => {
    // Skip emotion/mui copies (we handled those earlier)
    if (
      style.getAttribute('data-emotion') ||
      style.getAttribute('data-mui-style')
    )
      return;

    const newStyle = targetDoc.createElement('style');
    newStyle.textContent = style.textContent;
    targetDoc.head.appendChild(newStyle);
  });
};
// ------------------

export const copyStyle = (targetDoc: Document, style: HTMLStyleElement) => {
  const newStyle = targetDoc.createElement('style');
  newStyle.textContent = style.textContent;
  targetDoc.head.appendChild(newStyle);
};
// -----------------------

export const copyStyleLink = (targetDoc: Document, style: HTMLLinkElement) => {
  if (style.href) {
    const newLinkEl = targetDoc.createElement('link');
    newLinkEl.rel = 'stylesheet';
    newLinkEl.href = style.href;
    targetDoc.head.appendChild(newLinkEl);
  }
};
// -----------------------

export const observeStyles = (sourceDoc: Document, targetDoc: Document) => {
  const observer = new MutationObserver((mutations: MutationRecord[]) => {
    mutations.forEach((mutation: MutationRecord) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node: Node) => {
          if (node instanceof HTMLElement) {
            if (
              node.tagName === 'LINK' &&
              (node as HTMLLinkElement).rel === 'stylesheet' &&
              targetDoc
            ) {
              copyStyleLink(targetDoc, node as HTMLLinkElement);
            } else if (node.tagName === 'STYLE' && targetDoc) {
              copyStyle(targetDoc, node as HTMLStyleElement);
            }
          }
        });
      }
    });
  });

  // Start observing the head element for child additions
  observer.observe(sourceDoc.head, {childList: true});
  return observer;
};
